<template>
  <div style="margin-top:100px; margin-left:50px; margin-right:50px">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>

    <div v-if="habilitado">
      <h1>Mensajes</h1>

      <div v-if="messages.length == 0 && !error" style="text-align:center; padding:20px">
        <h3>No hay mensajes a aprobar</h3>
        <img src="public/images/site/background-no-activity.svg" width="200px" alt="Arkidia" />
      </div>

      <div v-if="messages.length>0 && !error" class="container"></div>

      <div
        class="card-group"
        style="width:80%;margin-top:20px; margin-left:10%; border-radius:15px; display:block"
      >
        <div
          class="card border-light mb-3"
          style="width:100%"
          v-for="(comentario,index) in messages"
          v-bind:key="index"
        >
          <div class="card-header" style="border-radius:15px">
            <img
              v-if="comentario.ind_comentario == 1"
              src="public/images/site/delete.svg"
              @click="eliminarComentario(comentario,index)"
              style="width:30px; vertical-align:super; cursor:pointer; position:absolute; margin-left:93%"
            />

            <b>{{comentario.alias}}</b>
            ({{comentario.usuario_comentario}}) dijo:
            <i>{{comentario.comentario}}</i>

            <div v-if="comentario.secuencia != 'A' && comentario.secuencia != 'R'">
              <b-button
                class="mt-3"
                variant="success"
                block
                @click="aprobar(comentario,index)"
              >Aprobar</b-button>
              <b-button
                class="mt-2"
                variant="danger"
                block
                @click="rechazar(comentario,index)"
              >Rechazar</b-button>
            </div>
            <div v-if="comentario.secuencia=='A'" style="text-align:center; padding:10px">
              <h5>Aprobado</h5>
            </div>
            <div v-if="comentario.secuencia=='R'" style="text-align:center; padding:10px">
              <h5 style="color: darkred">Rechazado</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";

export default {
  name: "app",
  data() {
    return {
      messages: [],
      error: false,
      errorMensaje: "",
      errorMessage: "",
      pendiente: true,
      habilitado: false
    };
  },
  methods: {
    buscarMensajes() {
      var self = this;
      fetch(
        self.pathAPI +
          "comentarios.php?usuario=" +
          this.userLogged.user +
          "&estado=B"
      )
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "ERROR") {
            self.error = true;
            self.errorMensaje = "al recuperar los mensajes";
            console.log(data);
          } else {
            console.log(data)
            self.messages = data;
          }

          const loader = document.querySelector(".loader");
          loader.className += " hidden";
        });
    },

    aprobar(message, index) {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_challenge=" +
        message.id_challenge +
        "&usuario_challenge=" +
        message.usuario_challenge +
        "&secuencia=" +
        message.secuencia +
        "&estado=P"),
      fetch(this.pathAPI + "comentarios.php?" + bodyApi, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          this.messages[index].secuencia = "A";
        })
        .catch(() => {
          this.messages[index].secuencia = "A";
        });
    },
    rechazar(message, index) {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_challenge=" +
        message.id_challenge +
        "&usuario_challenge=" +
        message.usuario_challenge +
        "&secuencia=" +
        message.secuencia +
        "&estado=R"),
      fetch(this.pathAPI + "comentarios.php?" + bodyApi, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          this.messages[index].secuencia = "R";
        })
        .catch(() => {
          console.log("error");
        });
    }
  },
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias", "cursoSeleccionado"])
  },
  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError
  },

  mounted: function() {
    console.log("administrador")
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      this.buscarMensajes();
    } else {
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>


<style scoped>
.lds-circle {
  display: inline-block;
  transform: translateZ(1px);
}
.lds-circle > div {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 8px;
  border-radius: 50%;
  background: rgb(16, 131, 112);
  animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.accion {
  background: #f0eeee;
  padding: 5px 20px;
  border-radius: 15px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminMessages.vue